<template>
  <div class="Address-wrap">
    <yzy-dropdown-menu
      v-if="option.length > 1"
      class="address-dropdown"
      active-color="#306BE5"
    >
      <yzy-dropdown-item
        @change="getUnitAdminList"
        v-model="value"
        :options="option"
      />
    </yzy-dropdown-menu>
    <p class="dropdown-box address-dropdown" v-else>
      {{ option[0].text }}
    </p>
    <MTable
      v-if="uncertainData.length"
      :column="tableColumn"
      :data="uncertainData"
    />
    <div class="no-admin" v-else>
      <img class="img" src="../assets/images/default.jpg" alt="auth" />
      <p class="account-font">该单位尚未配置单位通讯录管理员</p>
    </div>
    <!-- <yzy-loading class="loading" v-show="isLoading" /> -->
  </div>
</template>
<script>
import * as api from "@/api/admin";
import MTable from "@/components/mtable";
import { mapState } from "vuex";

export default {
  components: {
    MTable,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      // isLoading: false,
      value: 0,
      option: [{}],
      tableColumn: [
        {
          title: "单位通讯录管理员",
          prop: "name",
        },
      ],
      uncertainData: [],
    };
  },
  mounted() {
    if (!this.userInfo.unitList) {
      return;
    }
    this.value = this.userInfo.unitList[0].orgId;
    this.option = this.userInfo.unitList.map((m) => ({
      text: m.orgName,
      value: m.orgId,
    }));
    this.getUnitAdminList();
  },
  methods: {
    async getUnitAdminList() {
      const { data, errcode } = await api.getUnitAdminList({
        unitId: this.value,
      });
      if (!errcode) {
        this.uncertainData = data;
        // this.uncertainData = [
        //   {
        //     id: "1386976348482174977",
        //     name: "康桓宇",
        //     type: 1,
        //   },
        //   {
        //     id: "1386976348482174978",
        //     name: "康研",
        //     type: 0,
        //   },
        //   {
        //     id: "1451399216940277761",
        //     name: "少秋",
        //     type: 0,
        //   },
        //   {
        //     id: "1451399216944472066",
        //     name: "肖永志",
        //     type: 0,
        //   },
        //   {
        //     id: "1451399216952860673",
        //     name: "高玲2",
        //     type: 0,
        //   },
        //   {
        //     id: "1451399216957054978",
        //     name: "18200012003",
        //     type: 0,
        //   },
        //   {
        //     id: "1451399216957054979",
        //     name: "周宏昌",
        //     type: 0,
        //   },
        //   {
        //     id: "1468825319648567298",
        //     name: "高玲4",
        //     type: 0,
        //   },
        //   {
        //     id: "1470240969575124994",
        //     name: "禤俊彦",
        //     type: 0,
        //   },
        //   {
        //     id: "1554316221623631874",
        //     name: "林震南",
        //     type: 0,
        //   },
        //   {
        //     id: "1565503823936507905",
        //     name: "褚展培",
        //     type: 1,
        //   },
        //   {
        //     id: "1569859606153371650",
        //     name: "伍世宁1",
        //     type: 0,
        //   },
        //   {
        //     id: "1470240969575124994",
        //     name: "禤俊彦",
        //     type: 0,
        //   },
        //   {
        //     id: "1554316221623631874",
        //     name: "林震南",
        //     type: 0,
        //   },
        //   {
        //     id: "1565503823936507905",
        //     name: "褚展培",
        //     type: 1,
        //   },
        //   {
        //     id: "1569859606153371650",
        //     name: "伍世宁1",
        //     type: 0,
        //   },
        //   {
        //     id: "1569870983102246914",
        //     name: "伍世宁1",
        //     type: 0,
        //   },
        //   {
        //     id: "1569859606153371650",
        //     name: "伍世宁1",
        //     type: 0,
        //   },
        //   {
        //     id: "1470240969575124994",
        //     name: "禤俊彦",
        //     type: 0,
        //   },
        //   {
        //     id: "1554316221623631874",
        //     name: "林震南",
        //     type: 0,
        //   },
        //   {
        //     id: "1565503823936507905",
        //     name: "褚展培",
        //     type: 1,
        //   },
        //   {
        //     id: "1569859606153371650",
        //     name: "伍世宁1",
        //     type: 0,
        //   },
        //   {
        //     id: "1569870983102246914",
        //     name: "伍世宁1",
        //     type: 0,
        //   },
        //   {
        //     id: "1569859606153371650",
        //     name: "伍世宁1",
        //     type: 0,
        //   },
        //   {
        //     id: "1470240969575124994",
        //     name: "禤俊彦",
        //     type: 0,
        //   },
        //   {
        //     id: "1554316221623631874",
        //     name: "林震南",
        //     type: 0,
        //   },
        //   {
        //     id: "1565503823936507905",
        //     name: "褚展培",
        //     type: 1,
        //   },
        //   {
        //     id: "1569859606153371650",
        //     name: "伍世宁1",
        //     type: 0,
        //   },
        //   {
        //     id: "1569870983102246914",
        //     name: "伍世宁1",
        //     type: 0,
        //   },
        // ];
      }
    },
  },
};
</script>
<style lang="scss">
.address-dropdown {
  margin-bottom: 50px;
}

.dropdown-box {
  height: 96px;
  line-height: 96px;
  font-size: 30px;
  text-align: center;
}

.yzy-dropdown-menu__title::after {
  opacity: 1;
  border: 4px solid;
  border-color: transparent transparent #333 #333;
}

.yzy-dropdown-menu__title--down::after {
  border-color: transparent transparent #306be5 #306be5;
}
.no-admin {
  padding-top: 50px;
  text-align: center;
  font-size: 30px;
  opacity: 0.6;
  color: #000000;
  .img {
    width: 320px;
    height: 320px;
    margin-bottom: 16px;
  }
}
.loading {
  text-align: center;
}
</style>
